import React, { Component } from 'react';
import { request } from 'http';


export default class AboutSimulation extends Component {
	render() {
		
		const {t,l} = this.props
		return <div style={{
			// position:"absolute",
			// left: 0,
			// top: 0,
			// width:360,
			// height:640,
		}}>
			
			{/* <img src={require('./img/logo.jpg')} style={{
				position:"absolute",
				left: 24,
				right: 24,
				top: 32,
				width:32,
				height:32
			}} /> */}
			<img src={require('./img/DanArielyLabs.png')} style={{
				position:"absolute",
				left: 24,
				top: 32,
				width:32,
				height:32 * (264/294)
			}} />
			<div style={{
				position:"absolute",
				left: 24,
				right: 24,
				top: 76,				
				fontSize:16,
			}}>
				{/* {global.isAndroidUser && <p>
					In this simulation, we ask you to treat this as if you are setting a new phone.
				</p>}
				{!global.isAndroidUser && <p>
					In this simulation, we ask you to treat 
					this as if you are got 
					<span style={{fontWeight:"bold"}}> a new Android phone.</span>
					You might not be familiar with android phone, 
					but we would like you to go through this process anyway.
				</p>} */}
				<p>We ask you to treat this simulation as if you were setting up a new phone.</p>
				<p style={{fontWeight:"bold"}}>
					We are not interested in your username, password, or any other personal information.
				</p>
				<p>
					We simply want to understand how you would set up a new phone.
				</p>
				<p>
					As you go through this process, 
					please try to imagine that this is your real phone and try 
					to set it up as you would set up your real phone. 
					Install the apps and services you want and don't install those you don't want.			
				</p>
				{/* <p>
					Specifically the goal of this simulation is to 
					understand what decisions you will make 
					regarding which apps and services to install, 
					and which apps and services not to install.
				</p>
				<p>
					Please pay extra attention to that part of 
					the process, And set it up in the way that 
					you set up your regular phone.
				</p> */}

			</div>
		
		</div>
	}

}



// WEBPACK FOOTER //
// ./src/Comp/AboutSimulation.js